module.exports = __webpack_public_path__ + "static/heliolite-logo-24c2d92de98c76773cfad0e42169ca23.png";